import { default as about_45usWjawxlkv4gMeta } from "/app/pages/about-us.vue?macro=true";
import { default as indexBtZzASPi3XMeta } from "/app/pages/admin/about-us/index.vue?macro=true";
import { default as indexD8KlV1XJSXMeta } from "/app/pages/admin/categories/index.vue?macro=true";
import { default as index2sPedsBSrOMeta } from "/app/pages/admin/contact-us/index.vue?macro=true";
import { default as indexCmk224EgwNMeta } from "/app/pages/admin/dev-tickets/index.vue?macro=true";
import { default as _91page_93ecdidvqHvsMeta } from "/app/pages/admin/dev-tickets/page/[page].vue?macro=true";
import { default as indexi8nCATZISJMeta } from "/app/pages/admin/index.vue?macro=true";
import { default as loginjuBiVElJesMeta } from "/app/pages/admin/login.vue?macro=true";
import { default as indexClFr1i7jsJMeta } from "/app/pages/admin/logs/index.vue?macro=true";
import { default as _91page_937MnOMxaUuiMeta } from "/app/pages/admin/logs/page/[page].vue?macro=true";
import { default as indexLKtTjox5yRMeta } from "/app/pages/admin/metas/index.vue?macro=true";
import { default as _91postId_93rVicZLKtCuMeta } from "/app/pages/admin/posts/[postId].vue?macro=true";
import { default as createFRz4kokehoMeta } from "/app/pages/admin/posts/create.vue?macro=true";
import { default as index2RdkxBCEndMeta } from "/app/pages/admin/posts/index.vue?macro=true";
import { default as _91page_93tJVr8iZRsgMeta } from "/app/pages/admin/posts/page/[page].vue?macro=true";
import { default as indexthcHqoDnbaMeta } from "/app/pages/admin/rules/index.vue?macro=true";
import { default as indexuzVvjIcFh4Meta } from "/app/pages/admin/slides/index.vue?macro=true";
import { default as indexYm9dzWmM2AMeta } from "/app/pages/admin/users/index.vue?macro=true";
import { default as _91page_93TxTzDWQjxgMeta } from "/app/pages/admin/users/page/[page].vue?macro=true";
import { default as auth7tE1sZcZDUMeta } from "/app/pages/auth.vue?macro=true";
import { default as index2769uKMcaUMeta } from "/app/pages/blog/category/[categoryId]/index.vue?macro=true";
import { default as _91page_93DlmiysDY4YMeta } from "/app/pages/blog/category/[categoryId]/page/[page].vue?macro=true";
import { default as indexgWaMlevJ7RMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as _91page_93XjZzxmj3IbMeta } from "/app/pages/blog/page/[page].vue?macro=true";
import { default as _91articleId_93QLDgB5XpSwMeta } from "/app/pages/blog/single/[articleId].vue?macro=true";
import { default as authucrRwAIstcMeta } from "/app/pages/company/[companyId]/auth.vue?macro=true";
import { default as _91careerId_93EwdhAyE8u2Meta } from "/app/pages/company/[companyId]/careers/[careerId].vue?macro=true";
import { default as indexwmcDJf4IBBMeta } from "/app/pages/company/[companyId]/careers/index.vue?macro=true";
import { default as index5OYAMohbpqMeta } from "/app/pages/company/announcements/index.vue?macro=true";
import { default as indexBERcvrMWEXMeta } from "/app/pages/company/attendances/index.vue?macro=true";
import { default as _91customPageId_934vbLCJpxWuMeta } from "/app/pages/company/custom-pages/[customPageId].vue?macro=true";
import { default as indexmLLECboU3KMeta } from "/app/pages/company/disciplinary-notes/index.vue?macro=true";
import { default as indexadJieniFk0Meta } from "/app/pages/company/index.vue?macro=true";
import { default as indexOcqz591kmcMeta } from "/app/pages/company/payrolls/[type]/index.vue?macro=true";
import { default as _91page_93Qm4ZIAmk8pMeta } from "/app/pages/company/payrolls/[type]/page/[page].vue?macro=true";
import { default as indexqeh6IjdhugMeta } from "/app/pages/company/performance-reviews/[type]/index.vue?macro=true";
import { default as _91page_93jEkR1Vq8olMeta } from "/app/pages/company/performance-reviews/[type]/page/[page].vue?macro=true";
import { default as kanbanMzkoueWUfjMeta } from "/app/pages/company/projects/[projectId]/kanban.vue?macro=true";
import { default as indexgH8Abc5865Meta } from "/app/pages/company/projects/index.vue?macro=true";
import { default as _91page_93gMa2tCemAeMeta } from "/app/pages/company/projects/page/[page].vue?macro=true";
import { default as contact_45uszp1HYnA7MsMeta } from "/app/pages/contact-us.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as indexw38AHfxN8MMeta } from "/app/pages/panel/announcements/index.vue?macro=true";
import { default as _91page_938fuRmmZVCTMeta } from "/app/pages/panel/announcements/page/[page].vue?macro=true";
import { default as _91userId_93HXUTvAAL8YMeta } from "/app/pages/panel/attendances/[userId].vue?macro=true";
import { default as indexWT5Nl6TpWcMeta } from "/app/pages/panel/attendances/index.vue?macro=true";
import { default as _91page_939JudQw2egjMeta } from "/app/pages/panel/attendances/page/[page].vue?macro=true";
import { default as index3ikqWj9rvsMeta } from "/app/pages/panel/careers/index.vue?macro=true";
import { default as indexrqSD5JqMCNMeta } from "/app/pages/panel/careers/requests/index.vue?macro=true";
import { default as _91page_93ZiNQNkelMjMeta } from "/app/pages/panel/careers/requests/page/[page].vue?macro=true";
import { default as indexX78faUHE1OMeta } from "/app/pages/panel/categories/index.vue?macro=true";
import { default as company_45settingsb4QBkTAfK7Meta } from "/app/pages/panel/company-settings.vue?macro=true";
import { default as _91customPageId_93Fzo7tBifzrMeta } from "/app/pages/panel/custom-pages/[customPageId].vue?macro=true";
import { default as indexjJAH8jeFOPMeta } from "/app/pages/panel/custom-pages/index.vue?macro=true";
import { default as _91page_93fyY3J8z9jCMeta } from "/app/pages/panel/custom-pages/page/[page].vue?macro=true";
import { default as dashboardCmMeVTnR0TMeta } from "/app/pages/panel/dashboard.vue?macro=true";
import { default as _91userId_93lkEEj1zwMXMeta } from "/app/pages/panel/disciplinary-notes/[userId].vue?macro=true";
import { default as indexeldpvoqPovMeta } from "/app/pages/panel/disciplinary-notes/index.vue?macro=true";
import { default as _91page_93dM5oVPqYzUMeta } from "/app/pages/panel/disciplinary-notes/page/[page].vue?macro=true";
import { default as organization_45chart9SQUPSYcRMMeta } from "/app/pages/panel/organization-chart.vue?macro=true";
import { default as columnsMlk4DoDFQ2Meta } from "/app/pages/panel/payrolls/[type]/groups/columns.vue?macro=true";
import { default as index9oxe9NuwwhMeta } from "/app/pages/panel/payrolls/[type]/groups/index.vue?macro=true";
import { default as _91page_937Pdvc31EM9Meta } from "/app/pages/panel/payrolls/[type]/groups/page/[page].vue?macro=true";
import { default as indexRx6MzhFheKMeta } from "/app/pages/panel/payrolls/[type]/index.vue?macro=true";
import { default as _91page_93Ne4HrVRi7aMeta } from "/app/pages/panel/payrolls/[type]/page/[page].vue?macro=true";
import { default as columnsRiab00BXZuMeta } from "/app/pages/panel/performance-reviews/[type]/groups/columns.vue?macro=true";
import { default as index84Uy4mCroWMeta } from "/app/pages/panel/performance-reviews/[type]/groups/index.vue?macro=true";
import { default as _91page_93F5UUtDrNemMeta } from "/app/pages/panel/performance-reviews/[type]/groups/page/[page].vue?macro=true";
import { default as indexoKySY8qWQKMeta } from "/app/pages/panel/performance-reviews/[type]/index.vue?macro=true";
import { default as _91page_93uPYVBwUsKAMeta } from "/app/pages/panel/performance-reviews/[type]/page/[page].vue?macro=true";
import { default as kanbanXiSz9mJVFzMeta } from "/app/pages/panel/projects/[projectId]/kanban.vue?macro=true";
import { default as indexM84jdB1zR5Meta } from "/app/pages/panel/projects/index.vue?macro=true";
import { default as _91page_93YGOMw4dSmDMeta } from "/app/pages/panel/projects/page/[page].vue?macro=true";
import { default as index8J4t2SRijkMeta } from "/app/pages/panel/projects/private/index.vue?macro=true";
import { default as _91page_93PFqmWv5jFaMeta } from "/app/pages/panel/projects/private/page/[page].vue?macro=true";
import { default as indexjs4BhfXdlEMeta } from "/app/pages/panel/roles/index.vue?macro=true";
import { default as indexCbacYQBgJqMeta } from "/app/pages/panel/users/index.vue?macro=true";
import { default as _91page_93mn7tdF9kmUMeta } from "/app/pages/panel/users/page/[page].vue?macro=true";
import { default as rulesCVy0F1SzKVMeta } from "/app/pages/rules.vue?macro=true";
export default [
  {
    name: about_45usWjawxlkv4gMeta?.name ?? "about-us",
    path: about_45usWjawxlkv4gMeta?.path ?? "/about-us",
    meta: about_45usWjawxlkv4gMeta || {},
    alias: about_45usWjawxlkv4gMeta?.alias || [],
    redirect: about_45usWjawxlkv4gMeta?.redirect || undefined,
    component: () => import("/app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: indexBtZzASPi3XMeta?.name ?? "admin-about-us",
    path: indexBtZzASPi3XMeta?.path ?? "/admin/about-us",
    meta: indexBtZzASPi3XMeta || {},
    alias: indexBtZzASPi3XMeta?.alias || [],
    redirect: indexBtZzASPi3XMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexD8KlV1XJSXMeta?.name ?? "admin-categories",
    path: indexD8KlV1XJSXMeta?.path ?? "/admin/categories",
    meta: indexD8KlV1XJSXMeta || {},
    alias: indexD8KlV1XJSXMeta?.alias || [],
    redirect: indexD8KlV1XJSXMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/categories/index.vue").then(m => m.default || m)
  },
  {
    name: index2sPedsBSrOMeta?.name ?? "admin-contact-us",
    path: index2sPedsBSrOMeta?.path ?? "/admin/contact-us",
    meta: index2sPedsBSrOMeta || {},
    alias: index2sPedsBSrOMeta?.alias || [],
    redirect: index2sPedsBSrOMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/contact-us/index.vue").then(m => m.default || m)
  },
  {
    name: indexCmk224EgwNMeta?.name ?? "admin-dev-tickets",
    path: indexCmk224EgwNMeta?.path ?? "/admin/dev-tickets",
    meta: indexCmk224EgwNMeta || {},
    alias: indexCmk224EgwNMeta?.alias || [],
    redirect: indexCmk224EgwNMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/dev-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93ecdidvqHvsMeta?.name ?? "admin-dev-tickets-page-page",
    path: _91page_93ecdidvqHvsMeta?.path ?? "/admin/dev-tickets/page/:page()",
    meta: _91page_93ecdidvqHvsMeta || {},
    alias: _91page_93ecdidvqHvsMeta?.alias || [],
    redirect: _91page_93ecdidvqHvsMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/dev-tickets/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexi8nCATZISJMeta?.name ?? "admin",
    path: indexi8nCATZISJMeta?.path ?? "/admin",
    meta: indexi8nCATZISJMeta || {},
    alias: indexi8nCATZISJMeta?.alias || [],
    redirect: indexi8nCATZISJMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: loginjuBiVElJesMeta?.name ?? "admin-login",
    path: loginjuBiVElJesMeta?.path ?? "/admin/login",
    meta: loginjuBiVElJesMeta || {},
    alias: loginjuBiVElJesMeta?.alias || [],
    redirect: loginjuBiVElJesMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/login.vue").then(m => m.default || m)
  },
  {
    name: indexClFr1i7jsJMeta?.name ?? "admin-logs",
    path: indexClFr1i7jsJMeta?.path ?? "/admin/logs",
    meta: indexClFr1i7jsJMeta || {},
    alias: indexClFr1i7jsJMeta?.alias || [],
    redirect: indexClFr1i7jsJMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/logs/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_937MnOMxaUuiMeta?.name ?? "admin-logs-page-page",
    path: _91page_937MnOMxaUuiMeta?.path ?? "/admin/logs/page/:page()",
    meta: _91page_937MnOMxaUuiMeta || {},
    alias: _91page_937MnOMxaUuiMeta?.alias || [],
    redirect: _91page_937MnOMxaUuiMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/logs/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexLKtTjox5yRMeta?.name ?? "admin-metas",
    path: indexLKtTjox5yRMeta?.path ?? "/admin/metas",
    meta: indexLKtTjox5yRMeta || {},
    alias: indexLKtTjox5yRMeta?.alias || [],
    redirect: indexLKtTjox5yRMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/metas/index.vue").then(m => m.default || m)
  },
  {
    name: _91postId_93rVicZLKtCuMeta?.name ?? "admin-posts-postId",
    path: _91postId_93rVicZLKtCuMeta?.path ?? "/admin/posts/:postId()",
    meta: _91postId_93rVicZLKtCuMeta || {},
    alias: _91postId_93rVicZLKtCuMeta?.alias || [],
    redirect: _91postId_93rVicZLKtCuMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/posts/[postId].vue").then(m => m.default || m)
  },
  {
    name: createFRz4kokehoMeta?.name ?? "admin-posts-create",
    path: createFRz4kokehoMeta?.path ?? "/admin/posts/create",
    meta: createFRz4kokehoMeta || {},
    alias: createFRz4kokehoMeta?.alias || [],
    redirect: createFRz4kokehoMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/posts/create.vue").then(m => m.default || m)
  },
  {
    name: index2RdkxBCEndMeta?.name ?? "admin-posts",
    path: index2RdkxBCEndMeta?.path ?? "/admin/posts",
    meta: index2RdkxBCEndMeta || {},
    alias: index2RdkxBCEndMeta?.alias || [],
    redirect: index2RdkxBCEndMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/posts/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93tJVr8iZRsgMeta?.name ?? "admin-posts-page-page",
    path: _91page_93tJVr8iZRsgMeta?.path ?? "/admin/posts/page/:page()",
    meta: _91page_93tJVr8iZRsgMeta || {},
    alias: _91page_93tJVr8iZRsgMeta?.alias || [],
    redirect: _91page_93tJVr8iZRsgMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/posts/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexthcHqoDnbaMeta?.name ?? "admin-rules",
    path: indexthcHqoDnbaMeta?.path ?? "/admin/rules",
    meta: indexthcHqoDnbaMeta || {},
    alias: indexthcHqoDnbaMeta?.alias || [],
    redirect: indexthcHqoDnbaMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/rules/index.vue").then(m => m.default || m)
  },
  {
    name: indexuzVvjIcFh4Meta?.name ?? "admin-slides",
    path: indexuzVvjIcFh4Meta?.path ?? "/admin/slides",
    meta: indexuzVvjIcFh4Meta || {},
    alias: indexuzVvjIcFh4Meta?.alias || [],
    redirect: indexuzVvjIcFh4Meta?.redirect || undefined,
    component: () => import("/app/pages/admin/slides/index.vue").then(m => m.default || m)
  },
  {
    name: indexYm9dzWmM2AMeta?.name ?? "admin-users",
    path: indexYm9dzWmM2AMeta?.path ?? "/admin/users",
    meta: indexYm9dzWmM2AMeta || {},
    alias: indexYm9dzWmM2AMeta?.alias || [],
    redirect: indexYm9dzWmM2AMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/users/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93TxTzDWQjxgMeta?.name ?? "admin-users-page-page",
    path: _91page_93TxTzDWQjxgMeta?.path ?? "/admin/users/page/:page()",
    meta: _91page_93TxTzDWQjxgMeta || {},
    alias: _91page_93TxTzDWQjxgMeta?.alias || [],
    redirect: _91page_93TxTzDWQjxgMeta?.redirect || undefined,
    component: () => import("/app/pages/admin/users/page/[page].vue").then(m => m.default || m)
  },
  {
    name: auth7tE1sZcZDUMeta?.name ?? "auth",
    path: auth7tE1sZcZDUMeta?.path ?? "/auth",
    meta: auth7tE1sZcZDUMeta || {},
    alias: auth7tE1sZcZDUMeta?.alias || [],
    redirect: auth7tE1sZcZDUMeta?.redirect || undefined,
    component: () => import("/app/pages/auth.vue").then(m => m.default || m)
  },
  {
    name: index2769uKMcaUMeta?.name ?? "blog-category-categoryId",
    path: index2769uKMcaUMeta?.path ?? "/blog/category/:categoryId()",
    meta: index2769uKMcaUMeta || {},
    alias: index2769uKMcaUMeta?.alias || [],
    redirect: index2769uKMcaUMeta?.redirect || undefined,
    component: () => import("/app/pages/blog/category/[categoryId]/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93DlmiysDY4YMeta?.name ?? "blog-category-categoryId-page-page",
    path: _91page_93DlmiysDY4YMeta?.path ?? "/blog/category/:categoryId()/page/:page()",
    meta: _91page_93DlmiysDY4YMeta || {},
    alias: _91page_93DlmiysDY4YMeta?.alias || [],
    redirect: _91page_93DlmiysDY4YMeta?.redirect || undefined,
    component: () => import("/app/pages/blog/category/[categoryId]/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexgWaMlevJ7RMeta?.name ?? "blog",
    path: indexgWaMlevJ7RMeta?.path ?? "/blog",
    meta: indexgWaMlevJ7RMeta || {},
    alias: indexgWaMlevJ7RMeta?.alias || [],
    redirect: indexgWaMlevJ7RMeta?.redirect || undefined,
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93XjZzxmj3IbMeta?.name ?? "blog-page-page",
    path: _91page_93XjZzxmj3IbMeta?.path ?? "/blog/page/:page()",
    meta: _91page_93XjZzxmj3IbMeta || {},
    alias: _91page_93XjZzxmj3IbMeta?.alias || [],
    redirect: _91page_93XjZzxmj3IbMeta?.redirect || undefined,
    component: () => import("/app/pages/blog/page/[page].vue").then(m => m.default || m)
  },
  {
    name: _91articleId_93QLDgB5XpSwMeta?.name ?? "blog-single-articleId",
    path: _91articleId_93QLDgB5XpSwMeta?.path ?? "/blog/single/:articleId()",
    meta: _91articleId_93QLDgB5XpSwMeta || {},
    alias: _91articleId_93QLDgB5XpSwMeta?.alias || [],
    redirect: _91articleId_93QLDgB5XpSwMeta?.redirect || undefined,
    component: () => import("/app/pages/blog/single/[articleId].vue").then(m => m.default || m)
  },
  {
    name: authucrRwAIstcMeta?.name ?? "company-companyId-auth",
    path: authucrRwAIstcMeta?.path ?? "/company/:companyId()/auth",
    meta: authucrRwAIstcMeta || {},
    alias: authucrRwAIstcMeta?.alias || [],
    redirect: authucrRwAIstcMeta?.redirect || undefined,
    component: () => import("/app/pages/company/[companyId]/auth.vue").then(m => m.default || m)
  },
  {
    name: _91careerId_93EwdhAyE8u2Meta?.name ?? "company-companyId-careers-careerId",
    path: _91careerId_93EwdhAyE8u2Meta?.path ?? "/company/:companyId()/careers/:careerId()",
    meta: _91careerId_93EwdhAyE8u2Meta || {},
    alias: _91careerId_93EwdhAyE8u2Meta?.alias || [],
    redirect: _91careerId_93EwdhAyE8u2Meta?.redirect || undefined,
    component: () => import("/app/pages/company/[companyId]/careers/[careerId].vue").then(m => m.default || m)
  },
  {
    name: indexwmcDJf4IBBMeta?.name ?? "company-companyId-careers",
    path: indexwmcDJf4IBBMeta?.path ?? "/company/:companyId()/careers",
    meta: indexwmcDJf4IBBMeta || {},
    alias: indexwmcDJf4IBBMeta?.alias || [],
    redirect: indexwmcDJf4IBBMeta?.redirect || undefined,
    component: () => import("/app/pages/company/[companyId]/careers/index.vue").then(m => m.default || m)
  },
  {
    name: index5OYAMohbpqMeta?.name ?? "company-announcements",
    path: index5OYAMohbpqMeta?.path ?? "/company/announcements",
    meta: index5OYAMohbpqMeta || {},
    alias: index5OYAMohbpqMeta?.alias || [],
    redirect: index5OYAMohbpqMeta?.redirect || undefined,
    component: () => import("/app/pages/company/announcements/index.vue").then(m => m.default || m)
  },
  {
    name: indexBERcvrMWEXMeta?.name ?? "company-attendances",
    path: indexBERcvrMWEXMeta?.path ?? "/company/attendances",
    meta: indexBERcvrMWEXMeta || {},
    alias: indexBERcvrMWEXMeta?.alias || [],
    redirect: indexBERcvrMWEXMeta?.redirect || undefined,
    component: () => import("/app/pages/company/attendances/index.vue").then(m => m.default || m)
  },
  {
    name: _91customPageId_934vbLCJpxWuMeta?.name ?? "company-custom-pages-customPageId",
    path: _91customPageId_934vbLCJpxWuMeta?.path ?? "/company/custom-pages/:customPageId()",
    meta: _91customPageId_934vbLCJpxWuMeta || {},
    alias: _91customPageId_934vbLCJpxWuMeta?.alias || [],
    redirect: _91customPageId_934vbLCJpxWuMeta?.redirect || undefined,
    component: () => import("/app/pages/company/custom-pages/[customPageId].vue").then(m => m.default || m)
  },
  {
    name: indexmLLECboU3KMeta?.name ?? "company-disciplinary-notes",
    path: indexmLLECboU3KMeta?.path ?? "/company/disciplinary-notes",
    meta: indexmLLECboU3KMeta || {},
    alias: indexmLLECboU3KMeta?.alias || [],
    redirect: indexmLLECboU3KMeta?.redirect || undefined,
    component: () => import("/app/pages/company/disciplinary-notes/index.vue").then(m => m.default || m)
  },
  {
    name: indexadJieniFk0Meta?.name ?? "company",
    path: indexadJieniFk0Meta?.path ?? "/company",
    meta: indexadJieniFk0Meta || {},
    alias: indexadJieniFk0Meta?.alias || [],
    redirect: indexadJieniFk0Meta?.redirect || undefined,
    component: () => import("/app/pages/company/index.vue").then(m => m.default || m)
  },
  {
    name: indexOcqz591kmcMeta?.name ?? "company-payrolls-type",
    path: indexOcqz591kmcMeta?.path ?? "/company/payrolls/:type()",
    meta: indexOcqz591kmcMeta || {},
    alias: indexOcqz591kmcMeta?.alias || [],
    redirect: indexOcqz591kmcMeta?.redirect || undefined,
    component: () => import("/app/pages/company/payrolls/[type]/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93Qm4ZIAmk8pMeta?.name ?? "company-payrolls-type-page-page",
    path: _91page_93Qm4ZIAmk8pMeta?.path ?? "/company/payrolls/:type()/page/:page()",
    meta: _91page_93Qm4ZIAmk8pMeta || {},
    alias: _91page_93Qm4ZIAmk8pMeta?.alias || [],
    redirect: _91page_93Qm4ZIAmk8pMeta?.redirect || undefined,
    component: () => import("/app/pages/company/payrolls/[type]/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexqeh6IjdhugMeta?.name ?? "company-performance-reviews-type",
    path: indexqeh6IjdhugMeta?.path ?? "/company/performance-reviews/:type()",
    meta: indexqeh6IjdhugMeta || {},
    alias: indexqeh6IjdhugMeta?.alias || [],
    redirect: indexqeh6IjdhugMeta?.redirect || undefined,
    component: () => import("/app/pages/company/performance-reviews/[type]/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93jEkR1Vq8olMeta?.name ?? "company-performance-reviews-type-page-page",
    path: _91page_93jEkR1Vq8olMeta?.path ?? "/company/performance-reviews/:type()/page/:page()",
    meta: _91page_93jEkR1Vq8olMeta || {},
    alias: _91page_93jEkR1Vq8olMeta?.alias || [],
    redirect: _91page_93jEkR1Vq8olMeta?.redirect || undefined,
    component: () => import("/app/pages/company/performance-reviews/[type]/page/[page].vue").then(m => m.default || m)
  },
  {
    name: kanbanMzkoueWUfjMeta?.name ?? "company-projects-projectId-kanban",
    path: kanbanMzkoueWUfjMeta?.path ?? "/company/projects/:projectId()/kanban",
    meta: kanbanMzkoueWUfjMeta || {},
    alias: kanbanMzkoueWUfjMeta?.alias || [],
    redirect: kanbanMzkoueWUfjMeta?.redirect || undefined,
    component: () => import("/app/pages/company/projects/[projectId]/kanban.vue").then(m => m.default || m)
  },
  {
    name: indexgH8Abc5865Meta?.name ?? "company-projects",
    path: indexgH8Abc5865Meta?.path ?? "/company/projects",
    meta: indexgH8Abc5865Meta || {},
    alias: indexgH8Abc5865Meta?.alias || [],
    redirect: indexgH8Abc5865Meta?.redirect || undefined,
    component: () => import("/app/pages/company/projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93gMa2tCemAeMeta?.name ?? "company-projects-page-page",
    path: _91page_93gMa2tCemAeMeta?.path ?? "/company/projects/page/:page()",
    meta: _91page_93gMa2tCemAeMeta || {},
    alias: _91page_93gMa2tCemAeMeta?.alias || [],
    redirect: _91page_93gMa2tCemAeMeta?.redirect || undefined,
    component: () => import("/app/pages/company/projects/page/[page].vue").then(m => m.default || m)
  },
  {
    name: contact_45uszp1HYnA7MsMeta?.name ?? "contact-us",
    path: contact_45uszp1HYnA7MsMeta?.path ?? "/contact-us",
    meta: contact_45uszp1HYnA7MsMeta || {},
    alias: contact_45uszp1HYnA7MsMeta?.alias || [],
    redirect: contact_45uszp1HYnA7MsMeta?.redirect || undefined,
    component: () => import("/app/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect || undefined,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexw38AHfxN8MMeta?.name ?? "panel-announcements",
    path: indexw38AHfxN8MMeta?.path ?? "/panel/announcements",
    meta: indexw38AHfxN8MMeta || {},
    alias: indexw38AHfxN8MMeta?.alias || [],
    redirect: indexw38AHfxN8MMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/announcements/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_938fuRmmZVCTMeta?.name ?? "panel-announcements-page-page",
    path: _91page_938fuRmmZVCTMeta?.path ?? "/panel/announcements/page/:page()",
    meta: _91page_938fuRmmZVCTMeta || {},
    alias: _91page_938fuRmmZVCTMeta?.alias || [],
    redirect: _91page_938fuRmmZVCTMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/announcements/page/[page].vue").then(m => m.default || m)
  },
  {
    name: _91userId_93HXUTvAAL8YMeta?.name ?? "panel-attendances-userId",
    path: _91userId_93HXUTvAAL8YMeta?.path ?? "/panel/attendances/:userId()",
    meta: _91userId_93HXUTvAAL8YMeta || {},
    alias: _91userId_93HXUTvAAL8YMeta?.alias || [],
    redirect: _91userId_93HXUTvAAL8YMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/attendances/[userId].vue").then(m => m.default || m)
  },
  {
    name: indexWT5Nl6TpWcMeta?.name ?? "panel-attendances",
    path: indexWT5Nl6TpWcMeta?.path ?? "/panel/attendances",
    meta: indexWT5Nl6TpWcMeta || {},
    alias: indexWT5Nl6TpWcMeta?.alias || [],
    redirect: indexWT5Nl6TpWcMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/attendances/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_939JudQw2egjMeta?.name ?? "panel-attendances-page-page",
    path: _91page_939JudQw2egjMeta?.path ?? "/panel/attendances/page/:page()",
    meta: _91page_939JudQw2egjMeta || {},
    alias: _91page_939JudQw2egjMeta?.alias || [],
    redirect: _91page_939JudQw2egjMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/attendances/page/[page].vue").then(m => m.default || m)
  },
  {
    name: index3ikqWj9rvsMeta?.name ?? "panel-careers",
    path: index3ikqWj9rvsMeta?.path ?? "/panel/careers",
    meta: index3ikqWj9rvsMeta || {},
    alias: index3ikqWj9rvsMeta?.alias || [],
    redirect: index3ikqWj9rvsMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/careers/index.vue").then(m => m.default || m)
  },
  {
    name: indexrqSD5JqMCNMeta?.name ?? "panel-careers-requests",
    path: indexrqSD5JqMCNMeta?.path ?? "/panel/careers/requests",
    meta: indexrqSD5JqMCNMeta || {},
    alias: indexrqSD5JqMCNMeta?.alias || [],
    redirect: indexrqSD5JqMCNMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/careers/requests/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93ZiNQNkelMjMeta?.name ?? "panel-careers-requests-page-page",
    path: _91page_93ZiNQNkelMjMeta?.path ?? "/panel/careers/requests/page/:page()",
    meta: _91page_93ZiNQNkelMjMeta || {},
    alias: _91page_93ZiNQNkelMjMeta?.alias || [],
    redirect: _91page_93ZiNQNkelMjMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/careers/requests/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexX78faUHE1OMeta?.name ?? "panel-categories",
    path: indexX78faUHE1OMeta?.path ?? "/panel/categories",
    meta: indexX78faUHE1OMeta || {},
    alias: indexX78faUHE1OMeta?.alias || [],
    redirect: indexX78faUHE1OMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/categories/index.vue").then(m => m.default || m)
  },
  {
    name: company_45settingsb4QBkTAfK7Meta?.name ?? "panel-company-settings",
    path: company_45settingsb4QBkTAfK7Meta?.path ?? "/panel/company-settings",
    meta: company_45settingsb4QBkTAfK7Meta || {},
    alias: company_45settingsb4QBkTAfK7Meta?.alias || [],
    redirect: company_45settingsb4QBkTAfK7Meta?.redirect || undefined,
    component: () => import("/app/pages/panel/company-settings.vue").then(m => m.default || m)
  },
  {
    name: _91customPageId_93Fzo7tBifzrMeta?.name ?? "panel-custom-pages-customPageId",
    path: _91customPageId_93Fzo7tBifzrMeta?.path ?? "/panel/custom-pages/:customPageId()",
    meta: _91customPageId_93Fzo7tBifzrMeta || {},
    alias: _91customPageId_93Fzo7tBifzrMeta?.alias || [],
    redirect: _91customPageId_93Fzo7tBifzrMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/custom-pages/[customPageId].vue").then(m => m.default || m)
  },
  {
    name: indexjJAH8jeFOPMeta?.name ?? "panel-custom-pages",
    path: indexjJAH8jeFOPMeta?.path ?? "/panel/custom-pages",
    meta: indexjJAH8jeFOPMeta || {},
    alias: indexjJAH8jeFOPMeta?.alias || [],
    redirect: indexjJAH8jeFOPMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/custom-pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93fyY3J8z9jCMeta?.name ?? "panel-custom-pages-page-page",
    path: _91page_93fyY3J8z9jCMeta?.path ?? "/panel/custom-pages/page/:page()",
    meta: _91page_93fyY3J8z9jCMeta || {},
    alias: _91page_93fyY3J8z9jCMeta?.alias || [],
    redirect: _91page_93fyY3J8z9jCMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/custom-pages/page/[page].vue").then(m => m.default || m)
  },
  {
    name: dashboardCmMeVTnR0TMeta?.name ?? "panel-dashboard",
    path: dashboardCmMeVTnR0TMeta?.path ?? "/panel/dashboard",
    meta: dashboardCmMeVTnR0TMeta || {},
    alias: dashboardCmMeVTnR0TMeta?.alias || [],
    redirect: dashboardCmMeVTnR0TMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/dashboard.vue").then(m => m.default || m)
  },
  {
    name: _91userId_93lkEEj1zwMXMeta?.name ?? "panel-disciplinary-notes-userId",
    path: _91userId_93lkEEj1zwMXMeta?.path ?? "/panel/disciplinary-notes/:userId()",
    meta: _91userId_93lkEEj1zwMXMeta || {},
    alias: _91userId_93lkEEj1zwMXMeta?.alias || [],
    redirect: _91userId_93lkEEj1zwMXMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/disciplinary-notes/[userId].vue").then(m => m.default || m)
  },
  {
    name: indexeldpvoqPovMeta?.name ?? "panel-disciplinary-notes",
    path: indexeldpvoqPovMeta?.path ?? "/panel/disciplinary-notes",
    meta: indexeldpvoqPovMeta || {},
    alias: indexeldpvoqPovMeta?.alias || [],
    redirect: indexeldpvoqPovMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/disciplinary-notes/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93dM5oVPqYzUMeta?.name ?? "panel-disciplinary-notes-page-page",
    path: _91page_93dM5oVPqYzUMeta?.path ?? "/panel/disciplinary-notes/page/:page()",
    meta: _91page_93dM5oVPqYzUMeta || {},
    alias: _91page_93dM5oVPqYzUMeta?.alias || [],
    redirect: _91page_93dM5oVPqYzUMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/disciplinary-notes/page/[page].vue").then(m => m.default || m)
  },
  {
    name: organization_45chart9SQUPSYcRMMeta?.name ?? "panel-organization-chart",
    path: organization_45chart9SQUPSYcRMMeta?.path ?? "/panel/organization-chart",
    meta: organization_45chart9SQUPSYcRMMeta || {},
    alias: organization_45chart9SQUPSYcRMMeta?.alias || [],
    redirect: organization_45chart9SQUPSYcRMMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/organization-chart.vue").then(m => m.default || m)
  },
  {
    name: columnsMlk4DoDFQ2Meta?.name ?? "panel-payrolls-type-groups-columns",
    path: columnsMlk4DoDFQ2Meta?.path ?? "/panel/payrolls/:type()/groups/columns",
    meta: columnsMlk4DoDFQ2Meta || {},
    alias: columnsMlk4DoDFQ2Meta?.alias || [],
    redirect: columnsMlk4DoDFQ2Meta?.redirect || undefined,
    component: () => import("/app/pages/panel/payrolls/[type]/groups/columns.vue").then(m => m.default || m)
  },
  {
    name: index9oxe9NuwwhMeta?.name ?? "panel-payrolls-type-groups",
    path: index9oxe9NuwwhMeta?.path ?? "/panel/payrolls/:type()/groups",
    meta: index9oxe9NuwwhMeta || {},
    alias: index9oxe9NuwwhMeta?.alias || [],
    redirect: index9oxe9NuwwhMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/payrolls/[type]/groups/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_937Pdvc31EM9Meta?.name ?? "panel-payrolls-type-groups-page-page",
    path: _91page_937Pdvc31EM9Meta?.path ?? "/panel/payrolls/:type()/groups/page/:page()",
    meta: _91page_937Pdvc31EM9Meta || {},
    alias: _91page_937Pdvc31EM9Meta?.alias || [],
    redirect: _91page_937Pdvc31EM9Meta?.redirect || undefined,
    component: () => import("/app/pages/panel/payrolls/[type]/groups/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexRx6MzhFheKMeta?.name ?? "panel-payrolls-type",
    path: indexRx6MzhFheKMeta?.path ?? "/panel/payrolls/:type()",
    meta: indexRx6MzhFheKMeta || {},
    alias: indexRx6MzhFheKMeta?.alias || [],
    redirect: indexRx6MzhFheKMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/payrolls/[type]/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93Ne4HrVRi7aMeta?.name ?? "panel-payrolls-type-page-page",
    path: _91page_93Ne4HrVRi7aMeta?.path ?? "/panel/payrolls/:type()/page/:page()",
    meta: _91page_93Ne4HrVRi7aMeta || {},
    alias: _91page_93Ne4HrVRi7aMeta?.alias || [],
    redirect: _91page_93Ne4HrVRi7aMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/payrolls/[type]/page/[page].vue").then(m => m.default || m)
  },
  {
    name: columnsRiab00BXZuMeta?.name ?? "panel-performance-reviews-type-groups-columns",
    path: columnsRiab00BXZuMeta?.path ?? "/panel/performance-reviews/:type()/groups/columns",
    meta: columnsRiab00BXZuMeta || {},
    alias: columnsRiab00BXZuMeta?.alias || [],
    redirect: columnsRiab00BXZuMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/performance-reviews/[type]/groups/columns.vue").then(m => m.default || m)
  },
  {
    name: index84Uy4mCroWMeta?.name ?? "panel-performance-reviews-type-groups",
    path: index84Uy4mCroWMeta?.path ?? "/panel/performance-reviews/:type()/groups",
    meta: index84Uy4mCroWMeta || {},
    alias: index84Uy4mCroWMeta?.alias || [],
    redirect: index84Uy4mCroWMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/performance-reviews/[type]/groups/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93F5UUtDrNemMeta?.name ?? "panel-performance-reviews-type-groups-page-page",
    path: _91page_93F5UUtDrNemMeta?.path ?? "/panel/performance-reviews/:type()/groups/page/:page()",
    meta: _91page_93F5UUtDrNemMeta || {},
    alias: _91page_93F5UUtDrNemMeta?.alias || [],
    redirect: _91page_93F5UUtDrNemMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/performance-reviews/[type]/groups/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexoKySY8qWQKMeta?.name ?? "panel-performance-reviews-type",
    path: indexoKySY8qWQKMeta?.path ?? "/panel/performance-reviews/:type()",
    meta: indexoKySY8qWQKMeta || {},
    alias: indexoKySY8qWQKMeta?.alias || [],
    redirect: indexoKySY8qWQKMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/performance-reviews/[type]/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93uPYVBwUsKAMeta?.name ?? "panel-performance-reviews-type-page-page",
    path: _91page_93uPYVBwUsKAMeta?.path ?? "/panel/performance-reviews/:type()/page/:page()",
    meta: _91page_93uPYVBwUsKAMeta || {},
    alias: _91page_93uPYVBwUsKAMeta?.alias || [],
    redirect: _91page_93uPYVBwUsKAMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/performance-reviews/[type]/page/[page].vue").then(m => m.default || m)
  },
  {
    name: kanbanXiSz9mJVFzMeta?.name ?? "panel-projects-projectId-kanban",
    path: kanbanXiSz9mJVFzMeta?.path ?? "/panel/projects/:projectId()/kanban",
    meta: kanbanXiSz9mJVFzMeta || {},
    alias: kanbanXiSz9mJVFzMeta?.alias || [],
    redirect: kanbanXiSz9mJVFzMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/projects/[projectId]/kanban.vue").then(m => m.default || m)
  },
  {
    name: indexM84jdB1zR5Meta?.name ?? "panel-projects",
    path: indexM84jdB1zR5Meta?.path ?? "/panel/projects",
    meta: indexM84jdB1zR5Meta || {},
    alias: indexM84jdB1zR5Meta?.alias || [],
    redirect: indexM84jdB1zR5Meta?.redirect || undefined,
    component: () => import("/app/pages/panel/projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93YGOMw4dSmDMeta?.name ?? "panel-projects-page-page",
    path: _91page_93YGOMw4dSmDMeta?.path ?? "/panel/projects/page/:page()",
    meta: _91page_93YGOMw4dSmDMeta || {},
    alias: _91page_93YGOMw4dSmDMeta?.alias || [],
    redirect: _91page_93YGOMw4dSmDMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/projects/page/[page].vue").then(m => m.default || m)
  },
  {
    name: index8J4t2SRijkMeta?.name ?? "panel-projects-private",
    path: index8J4t2SRijkMeta?.path ?? "/panel/projects/private",
    meta: index8J4t2SRijkMeta || {},
    alias: index8J4t2SRijkMeta?.alias || [],
    redirect: index8J4t2SRijkMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/projects/private/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93PFqmWv5jFaMeta?.name ?? "panel-projects-private-page-page",
    path: _91page_93PFqmWv5jFaMeta?.path ?? "/panel/projects/private/page/:page()",
    meta: _91page_93PFqmWv5jFaMeta || {},
    alias: _91page_93PFqmWv5jFaMeta?.alias || [],
    redirect: _91page_93PFqmWv5jFaMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/projects/private/page/[page].vue").then(m => m.default || m)
  },
  {
    name: indexjs4BhfXdlEMeta?.name ?? "panel-roles",
    path: indexjs4BhfXdlEMeta?.path ?? "/panel/roles",
    meta: indexjs4BhfXdlEMeta || {},
    alias: indexjs4BhfXdlEMeta?.alias || [],
    redirect: indexjs4BhfXdlEMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/roles/index.vue").then(m => m.default || m)
  },
  {
    name: indexCbacYQBgJqMeta?.name ?? "panel-users",
    path: indexCbacYQBgJqMeta?.path ?? "/panel/users",
    meta: indexCbacYQBgJqMeta || {},
    alias: indexCbacYQBgJqMeta?.alias || [],
    redirect: indexCbacYQBgJqMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/users/index.vue").then(m => m.default || m)
  },
  {
    name: _91page_93mn7tdF9kmUMeta?.name ?? "panel-users-page-page",
    path: _91page_93mn7tdF9kmUMeta?.path ?? "/panel/users/page/:page()",
    meta: _91page_93mn7tdF9kmUMeta || {},
    alias: _91page_93mn7tdF9kmUMeta?.alias || [],
    redirect: _91page_93mn7tdF9kmUMeta?.redirect || undefined,
    component: () => import("/app/pages/panel/users/page/[page].vue").then(m => m.default || m)
  },
  {
    name: rulesCVy0F1SzKVMeta?.name ?? "rules",
    path: rulesCVy0F1SzKVMeta?.path ?? "/rules",
    meta: rulesCVy0F1SzKVMeta || {},
    alias: rulesCVy0F1SzKVMeta?.alias || [],
    redirect: rulesCVy0F1SzKVMeta?.redirect || undefined,
    component: () => import("/app/pages/rules.vue").then(m => m.default || m)
  }
]